import React from 'react';
import ConstitutionDayDesktop from '@assets/decorations/constitutionDay/ConstitutionDayDesktop.svg?url';
import ConstitutionDayMobile from '@assets/decorations/constitutionDay/ConstitutionDayMobile.svg?url';
import * as S from './Styles';

export const ConstitutionDay = () => (
  <>
    <S.DesktopWrapper>
      <img src={ConstitutionDayDesktop} alt="Nasjonaldagen" />
    </S.DesktopWrapper>
    <S.MobileWrapper>
      <img src={ConstitutionDayMobile} alt="Nasjonaldagen" />
    </S.MobileWrapper>
  </>
);
